import { MultiSelect } from "react-multi-select-component";
import { useEffect, useState } from "react";
import * as Icons from "react-icons/hi";
import { data } from "autoprefixer";
interface InputProps {
  label: string;
  name: string;
  type?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hasLabel?: boolean;
  placeHolder?: string;
  options: Array<{
    label: string;
    value: string;
  }>;
  icon?: {
    iconName: string;
    color?: string;
    size?: number;
  };
  data: any;
  onChange: (value: any) => void;
}

const MultipleSelectInput = (props: InputProps) => {
  const n = props.icon?.iconName ?? "";
  const [selected, setSelected] = useState([]);
  const IconComponent = (Icons as any)[n];
  useEffect(() => {
    if (selected.length > 0) {
      return props.onChange(selected);
    }
  }, [selected]);

  useEffect(() => {
    if (props.data !== undefined) {
      let newData = props.data.map((element) => ({
        value: element.value,
        checked: true,
        label: element.name
      }));
      setSelected(newData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e: any) => {
    props.onChange({ id: parseInt(e.target.value) });
  };


  return (
    <div
      className={`flex flex-col ${
        props.hasLabel && "space-y-2"
      } w-[100%] relative my-3`}
    >
      {props.hasLabel && (
        <label>
          {props.label}{" "}
          <span className="text-red-600">{props.required ? "*" : ""}</span>
        </label>
      )}
      <span className="absolute bottom-3 left-4">
        {props.icon === undefined || props.icon === null ? null : (
          <IconComponent size={props.icon.size} color={props.icon.color} />
        )}
      </span>
      {/* <pre>{JSON.stringify(selected)}</pre> */}
      <MultiSelect
        options={props.options}
        value={selected}
        onChange={setSelected}
        labelledBy="Select"
        // overrideStrings={{all}}
      />
      {/* <input placeholder={props.placeHolder} type={props.type} name={props.name} className={`h-14 md:h-16 border-[1px] px-4 py-2 rounded-md border-[#E4E4E7] ${props.icon !== undefined || props.icon !== null ? "pl-14" : ""} ${props.className}`} disabled={props.disabled} required={props.required}/> */}
    </div>
  );
};

export default MultipleSelectInput;
